<template>
    <div class="alert alert-danger" v-if="errors.length" ref="errors">
        <ul class="mb-0 pl-3" v-for="(error, index) in errorsTranslated" :key="'error' + index">
            <li class="text-danger">{{error}}</li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'ErrorMessages',
        computed: {
            errors() {
                return this.$store.state.errors;
            },
            errorsTranslated() {
                return this.errors.map(error => {
                    if ( error.text === "Code validation failed: reCaptcha-Check failed" ) {
                        return this.$i18n.t( 'validationForm.errors.recaptcha_failed.text' );
                    }
                    if (error.text === "field.pattern") {
                        return this.$i18n.t("errors." + error.field + "." + error.text);
                    }
                    return this.$i18n.t(error.text || error);
                });
            }
        },
        watch: {
            errors(errors) {
                if (errors.length) {
                    this.$nextTick(() => {
                        this.$refs.errors.scrollIntoView({
                            behavior: 'smooth'
                        });
                    });
                }
            }
        }
    }
</script>
